import Toggle from "../../../components/Toggle.jsx";
import LoadingComponent from "../../../components/LoadingComponent.jsx";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { ProjectApi } from "../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../api/utilities/useAuthorityConfiguration.js";
import toast from "react-hot-toast";
import { useErrorTranslation } from "../../../api/utilities/translateErrorMessage.js";
import Button from "../../../components/Button.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import YesNo from "../../../components/YesNo.jsx";
import ActionButton from "../../../components/ActionButton.jsx";
import { useRenderNumber } from "../../../api/utilities/useValueRenderers.js";

export default function ProjectDomain({ project, domainWithStats, onReload, onToggleChange, isSaving, isDisabled, isEnabled }) {
    const { t } = useTranslation();
    const { et } = useErrorTranslation();
    const authorityConfiguration = useAuthorityConfiguration();
    const renderNumber = useRenderNumber();

    const [deleteYesNoOpen, setDeleteYesNoOpen] = useState(false);
    const [deleteYesNoConfirmed, setDeleteYesNoConfirmed] = useState(false);

    useEffect(() => {
        if (deleteYesNoConfirmed !== true) {
            return;
        }

        new ProjectApi(authorityConfiguration)
            .deleteProjectDomain({
                projectId: project.id,
                deleteProjectDomainInput: {
                    hostName: domainWithStats.projectDomain.hostName,
                },
            })
            .then(() => {
                onReload();
            })
            .catch((e) => et(e).then((message) => { if (message) toast.error(message); }));
    }, [deleteYesNoConfirmed]);

    return [
        <YesNo
            key={'pd-yesno'}
            question={t('project.really-delete-domain-x', { domain: domainWithStats.projectDomain.hostName })}
            visible={deleteYesNoOpen || deleteYesNoConfirmed}
            setVisible={setDeleteYesNoOpen}
            onYes={() => setDeleteYesNoConfirmed(true)}
            loading={deleteYesNoConfirmed}
        />,
        <div
            key={'pd-row'}
            className={
                'comp__integrationListItem ' +
                'flex gap-2 justify-items-start items-center p-2' + ' ' +
                'px-4 mb-3 rounded-xl bg-white border-1' + ' ' +
                'dark:border-0 dark:bg-slate-800'
            }
        >
            <div className={'min-w-0 flex-1'}>
                <div className={'flex items-center'}>
                    <img src={domainWithStats.projectDomain.faviconUrl} alt={'favicon'} className={'w-4 h-4'} />
                    <strong className={'ml-2 truncate'}>{domainWithStats.projectDomain.hostName}</strong>
                </div>
                <div className={'mt-1 flex flex-wrap gap-x-4 text-sm text-slate-500 dark:text-slate-400'}>
                    <span>{t('project.domain-campaign-amount', { count: domainWithStats.projectDomainStats.campaignCount, formattedCount: renderNumber(domainWithStats.projectDomainStats.campaignCount) })}</span>
                    <span>{t('project.domain-ad-amount', { count: domainWithStats.projectDomainStats.adCount, formattedCount: renderNumber(domainWithStats.projectDomainStats.adCount) })}</span>
                    <span>{t('project.domain-order-amount', { count: domainWithStats.projectDomainStats.orderCount, formattedCount: renderNumber(domainWithStats.projectDomainStats.orderCount) })}</span>
                </div>
            </div>
            <LoadingComponent
                className={'ml-auto'}
                loadedClassName={'flex gap-2 items-center justify-center'}
                loading={isSaving}
            >
                <Toggle
                    enabled={isEnabled}
                    setEnabled={(newValue) => !isDisabled && onToggleChange(domainWithStats.projectDomain.hostName, newValue)}
                    disabled={isDisabled || isSaving}
                />
                {!domainWithStats.projectDomain.isBuiltin && !isDisabled && (
                    <ActionButton
                        icon={'trash'}
                        className={'align-center'}
                        disabled={domainWithStats.projectDomain.isBuiltin || isDisabled}
                        onClick={() => {
                            if (!domainWithStats.projectDomain.isBuiltin && !isDisabled) {
                                setDeleteYesNoOpen(true);
                            }
                        }}
                    >
                    </ActionButton>
                )}
            </LoadingComponent>
        </div>,
    ];
}
